
import PageState from "./state"
import mutations from "./mutations"
import {getModule} from '@/store/store'
let APIS = {
  getSpeakerBySearch:`get /apis/baohuo-yuanchuang/speaker/store/search`
}
export default {
  ...getModule({
    state:new PageState(),
    mutations,
    actions:{},
    APIS,
    name:"searchByname"
  })
}